import React, { useState } from 'react'
import { getDetailedStars, getInitialStars } from '../../helpers/templateHelpers';

function Stars({ value, answerable = true, onMouseOver, onMouseLeave, onChange }) {

    const five = [0, 1, 2, 3, 4];
    
    const [score, setScore] = useState(value); 
    const [stars, setStars] = useState(getInitialStars(value, five));

    const drawHoveredStars = (key) => {
        let selectedStar  = value;
            let tmpUrls = [...five].map((item, i) => {
            if (key > -1) return i <= key ? "polna.svg" : "prazna.svg";
            if (selectedStar >= 0)  return i < selectedStar ? "polna.svg" : "prazna.svg";
            return "prazna.svg";
        });
        setStars(tmpUrls);
    }

    const handleMouseEnter = (key) => {
        if (!answerable) return;
        onMouseOver?.(key + 1);
        drawHoveredStars(key);
    };
    const handleMouseLeave = (key) => {
        if (!answerable) return;
        onMouseLeave?.(score);
        drawHoveredStars(score-1);
    };

    const handleClickStar = (key) => {
        setScore(key + 1);       
        onChange?.(key + 1);
    };


    return (
        <div className="starsWidgetWrap">
            {stars.map((starUrl, key) => {
                return (
                    <div key={key} className="singleStarWrap"
                        onMouseEnter={() => {handleMouseEnter(key)}}
                        onMouseLeave={() => {handleMouseLeave(key)}}
                        onClick={() => handleClickStar(key)}>
                        <img src={require(`../../assets/img/stars/${starUrl}`)} alt={value} />
                    </div>
                )
            })}

        </div>
    )
}

export default Stars